import { EngagementProductWithDeliveryInfoResponseDto } from '@epicuro-next/data/engagement/engagement-models';
import { ListProductReference } from '@epicuro-next/data/lists';
import {
  filterOutUnavailableDeliveryInfo,
  mapProductDeliveryInfoTotals,
} from '@epicuro-next/features/engagement/list-utils';

import { ListProductReferenceEntity } from '../models';

import { mapListProductReferenceDates } from './map-list-product-reference-dates';
import { mapListProductReferenceTotals } from './map-list-product-reference-totals';
import { mapProductDeliveryInfoToEarliestDeliveryDate } from './map-product-delivery-info-to-earliest-delivery-date';

export const mapProductReferencesToListProductEntity = (
  listId: string,
  currency: string,
  products: EngagementProductWithDeliveryInfoResponseDto[],
): ListProductReferenceEntity => {
  const productReferences = products.map(
    (product): ListProductReference => ({
      ...product,
      currency,
      ...mapProductDeliveryInfoTotals(product.deliveryInfo),
      earliestDeliveryDate: mapProductDeliveryInfoToEarliestDeliveryDate(
        product.deliveryInfo,
      ),
    }),
  );

  // DELETE AS TYPE
  const availableProducts = filterOutUnavailableDeliveryInfo(
    products as ListProductReference[],
  );

  return {
    listId,
    data: {
      currency,
      productReferences,
      allItemTotals: {
        ...mapListProductReferenceTotals(products),
        ...mapListProductReferenceDates(products),
      },
      availableItemTotals: {
        ...mapListProductReferenceTotals(availableProducts),
        ...mapListProductReferenceDates(availableProducts),
      },
    },
  };
};
